import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import UserTableHead from '../../components/molecules/UserTableHead';
import UserTableBody from '../../components/molecules/UserTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import ContentDialog from '../../components/molecules/ContentDialog';
import UserDetail from './UserDetail';
import { getUserDetail, downloadQrCode } from '../../actions/Users';
import { resetUserPasswordData, deleteUserData } from '../../libs/apis/UserApi';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      users: state.users.users,
      totalCount: state.users.totalCount,
      offset: state.users.offset
    }),
    dispatch => ({
      actions: bindActionCreators({ getUserDetail, downloadQrCode }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('userId', 'setUserId', ''),
  withState('accountId', 'setAccountId', ''),
  withState('displayName', 'setDisplayName', ''),
  withState('email', 'setEmail', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('status', 'setStatus', ''),
  withState('statusStr', 'setStatusStr', ''),
  withState('stripeCustomerId', 'setStripeCustomerId', ''),
  withState('message', 'setMessage', ''),
  withState('image', 'setImage', ''),
  withState('favoriteShops', 'setFavoriteShops', null),
  withState('follows', 'setFollows', null),
  withState('followers', 'setFollowers', null),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'userId'),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    users,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    setFullMessage,
    openDetailModal,
    updateOpenDetailModal,
    progress,
    rowsPerPage,
    page,
    selectedPage,
    totalCount,
    offset,
    targetRowId,
    setTargetRowId,
    order,
    orderBy,
    handleChangePage,
    handleChangeRowsPerPage,
    handleRequestSort,
    userId,
    setUserId,
    accountId,
    setAccountId,
    displayName,
    setDisplayName,
    email,
    setEmail,
    cognitoUserId,
    setCognitoUserId,
    status,
    setStatus,
    statusStr,
    setStatusStr,
    stripeCustomerId,
    setStripeCustomerId,
    message,
    setMessage,
    image,
    setImage,
    favoriteShops,
    setFavoriteShops,
    follows,
    setFollows,
    followers,
    setFollowers,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const moreMessageAction = msg => {
      setFullMessage(msg);
      updateOpenFullMessage(true);
    };

    const detail = {
      userId,
      accountId,
      displayName,
      email,
      cognitoUserId,
      status,
      statusStr,
      stripeCustomerId,
      message,
      image,
      favoriteShops,
      follows,
      followers,
      createdAt,
      updatedAt
    };
    const getUser = async id => {
      await actions.getUserDetail(id).then(detailData => {
        checkSession(detailData);
        setUserId(detailData.payload.userId);
        setAccountId(detailData.payload.accountId);
        setDisplayName(detailData.payload.displayName);
        setEmail(detailData.payload.email);
        setCognitoUserId(detailData.payload.cognitoUserId);
        setStatus(detailData.payload.status);
        setStatusStr(detailData.payload.statusStr);
        setStripeCustomerId(detailData.payload.stripeCustomerId);
        setMessage(detailData.payload.message);
        setImage(detailData.payload.image);
        setFavoriteShops(detailData.payload.favoriteShops);
        setFollows(detailData.payload.follows);
        setFollowers(detailData.payload.followers);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getUser(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const resetPasswordAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      resetUserPasswordData(params)
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.data === 0) alert('パスワードがリセットされました。');
          else alert('パスワードがリセットされません。');
        })
        .catch(() => {
          alert('パスワードがリセットされません。');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const deleteAction = uid => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      deleteUserData(uid)
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.data.code === 200) {
            alert('ユーザーを非表示しました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else alert('ユーザー非表示に失敗しました。');
        })
        .catch(() => {
          alert('ユーザー非表示に失敗しました。');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const addWaterMark = async blob => {
      const canvas = await new Promise(resolve => {
        const objectURL = URL.createObjectURL(blob);
        const c = document.createElement('canvas');
        c.width = 390;
        c.height = 390;
        const ctx = c.getContext('2d');
        const img = new Image();

        img.onload = () => {
          ctx.drawImage(img, 0, 0);
          ctx.fillStyle = 'red';
          ctx.textBaseline = 'bottom';
          ctx.font = "18px 'Roboto', 'Helvetica', 'Arial', sans-serif";
          ctx.fillText('', 42, 376);
          resolve(c);
        };
        img.src = objectURL;
        console.log('objectURL', objectURL);
      });

      return new Promise(resolve => {
        canvas.toBlob(
          newblob => {
            resolve(newblob);
          },
          'image/jpeg',
          1
        );
      });
    };

    const downloadQrBlob = async (blob, fileName) => {
      const newBlob = await addWaterMark(blob);
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(newBlob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(
          new Blob([newBlob], { type: 'image/jpeg' })
        );
        console.log('url', url);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const qrCodeAction = (id, name, suffixes) => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      actions.downloadQrCode(id, suffixes).then(response => {
        checkSession(response);
        if (response.type === 'DOWNLOAD_QRCODE_SUCCESS') {
          console.log('response.payload', response);
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (suffixes === 'GC') {
            downloadQrBlob(
              response.payload,
              `QRcode_GochiKid_${name}_${id}.jpg`
            );
          } else if (suffixes === 'GU') {
            downloadQrBlob(response.payload, `QRcode_${name}_${id}.jpg`);
          }
        } else {
          alert('QRコードダウンロードに失敗しました。');
          progress.updateLoading(false);
          progress.updateOpenProgress(false);
        }
      });
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <UserTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <UserTableBody
              users={users}
              emptyRows={emptyRows}
              page={page}
              qrCodeAction={qrCodeAction}
              rowsPerPage={rowsPerPage}
              messageViewAction={moreMessageAction}
              updateOpenDetailModal={updateOpenDetailModal}
              order={order}
              orderBy={orderBy}
              setTargetRowId={setTargetRowId}
              detailOpenAction={detailOpenAction}
              resetPasswordAction={resetPasswordAction}
              deleteAction={deleteAction}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={users}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <UserDetail
            updateOpenDetailModal={updateOpenDetailModal}
            targetRowId={targetRowId}
            detail={detail}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
